import type { TplTemplateVO } from '../_components/template-ui/types';

export function resolveViralTemplateCreditCost(tpl: Pick<TplTemplateVO, 'modelFee'>) {
  return tpl.modelFee?.amount || 0;
}
